import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    Button
} from '@material-ui/core';

import SiteConstraintInfoCards from './SiteConstraintInfoCards';
import Title from '../../Title';
import { setTabIndex } from '../../../../../redux/parcel/Actions';
import { compose } from 'redux';
import { connect } from 'react-redux';
import ConstraintTables from '../ConstraintTables';

class SiteConstraints extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        // Redux State
        intersections: PropTypes.array,
        // Redux Dispatch
        dispatchSetTabIndex: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.state = {
            isExpanded: false
        };

        this.handleNearbyClick = this.handleNearbyClick.bind(this);
        this.handleConstraintClick = this.handleConstraintClick.bind(this);
    }

    handleNearbyClick () {
        const { dispatchSetTabIndex } = this.props;
        dispatchSetTabIndex(1);
    }

    handleConstraintClick () {
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    }

    render () {
        const { classes, intersections } = this.props;
        const { isExpanded } = this.state;

        const isLoading = !Boolean(intersections);

        // ToDo Remove distance from here when have better threshold for warnings
        const filteredIntersections = intersections ? intersections.filter(intersection =>
            intersection.id !== null && intersection.score !== 0
        ) : null;

        return (
            <>
                <Title
                    title="SITE IMPACTS"
                    skeleton={isLoading}
                >
                    <Button
                        className={classes.nearbyButton}
                        onClick={this.handleNearbyClick}
                    >
                        View nearby
                    </Button>
                    {
                        filteredIntersections && filteredIntersections.length > 0 && <Button
                            className={classes.constraintsButton}
                            onClick={this.handleConstraintClick}
                        >
                            {
                                isExpanded ?
                                    'See less' :
                                    `See all impacts (${filteredIntersections.length})`
                            }
                        </Button>
                    }
                </Title>
                {
                    !isLoading && isExpanded && filteredIntersections.length > 0?
                        <ConstraintTables constraints={filteredIntersections} valueLabel="Impact" /> :
                        <SiteConstraintInfoCards constraints={filteredIntersections} />
                }
            </>
        );
    }
}

const style = theme => ({
    root: {
        '&> *':{
            marginBottom: '14px'
        }
    },
    nearbyButton: {
        ...theme.typography.caption,
        color: theme.palette.primary.light,
        marginRight: 'auto',
        textTransform: 'initial'
    },
    constraintsButton: {
        ...theme.typography.caption,
        textTransform: 'initial'
    }
});

const mapStateToProps = (state) => {
    const currentPolygon = state.parcelPanel.currentPolygonId && state.parcelPanel.polygons[state.parcelPanel.currentPolygonId];
    return {
        intersections: currentPolygon && currentPolygon.intersections
    };
};

const mapDispatchToProps = (dispatch) => ({
    dispatchSetTabIndex: (index) => dispatch(setTabIndex(index))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(SiteConstraints);